/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HammerIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABPklEQVR4nL2UvS5EQRiGj6BaetGJUqFwASfBafD9bDH7vWQrxeEOlNhYCWqdK3AFaCTi5xZcxEapIcjZOHaz1u4ZzniTSaY48zzfmW9mosgvI0RuJknqlajsOOcmWHDJincSa1EVi6XBk6ReIcV1Bs8HCZ6Za8ulVE6Km254r4QVu6R2wYzp0uDckbx+zRWPK85NFRaw2ukg+A/jpLhA7N4H3m4+Ya6wQGR9y0/wi8aT2M5/SPZ8JWtiS4El1vK+8STY95Go2mwR6AErzpxzo14Ssavs7RoIZ0WzswDncRyPFdkuUtwx8+Swyo/7LG52yRv9K8ftUHh2G/s1bbVam+/5rhEMnocV2yx4aD8rQ+Fih99/255UNxaivyYsXO3IZ1u8kqbpOCtegsDzkFrKircg8OgzrNjMjlkQeMh8ABrXqE3zh8YgAAAAAElFTkSuQmCC)
 */
export const HammerIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M1.23 21.13a1 1 0 0 1 0-1.41l7.48-7.47c.2-.2.51-.2.7 0l2.13 2.12c.2.2.2.5 0 .7l-7.48 7.48a1 1 0 0 1-1.41 0l-1.42-1.42ZM7.76 7.76l8.48 8.49a2 2 0 0 0 2.83 0l3.54-3.54a2 2 0 0 0 0-2.83l-2.94-2.94.65-.66a1 1 0 0 0 0-1.4l-1.41-1.42a1 1 0 0 0-1.41 0l-.66.65-2.72-2.71a2 2 0 0 0-2.83 0L7.76 4.93a2 2 0 0 0 0 2.83Z"
        className={colorClass}
      />
    </svg>
  );
};
